import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { ServiceCenterApplicationType } from "api"
import Shared from "theme/shared"

const Styled = {
  ResponseWrapper: styled.div`
    text-align: center;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  `,
  ResponseIcon: styled.img`
    width: 71px;
    height: 71px;
    object-fit: contain;
  `,
  ResponseTitle: styled(Typography)<{ component: string }>`
    color: ${(p) => p.theme.colors.duskBlue};
    margin: 0;
  `,
  ResponseText: styled(Typography)`
    font-weight: bold;
    font-size: 20px;
  `,
  ResponseButton: styled(Shared.Button)`
    height: 35px;
    font-size: 14px;
    width: auto;
    width: 150px;
    white-space: nowrap;
    margin-top: 16px;
  `,
}

type FormResponseProps = {
  onActionClick: () => void
  status: "success" | "failure"
  type: ServiceCenterApplicationType
}

const FormResponse = ({ onActionClick, status, type }: FormResponseProps) => {
  const icon = status === "success" ? "/success.svg" : "/cancel.svg"
  const title =
    status === "success" ? "פנייתך התקבלה בהצלחה" : "אירעה שגיאה בשליחת הטופס"

  const successDescription =
    type === "Contact"
      ? "נציג מרכז השירות יצור עמך קשר"
      : "נציג מרכז השירות יצור עמך קשר לתיאום מועד הגעתך"

  const description =
    status === "success"
      ? successDescription
      : "אנא פנה אל שירות הלקוחות באמצעות צור קשר בטלפון או באתר"

  return (
    <Styled.ResponseWrapper>
      <Styled.ResponseIcon src={icon} />
      <Styled.ResponseTitle variant="h1" component="p">
        {title}
      </Styled.ResponseTitle>
      <Styled.ResponseText>{description}</Styled.ResponseText>
      <Styled.ResponseButton
        variant="contained"
        color="primary"
        onClick={onActionClick}
      >
        חזרה לעמוד
      </Styled.ResponseButton>
    </Styled.ResponseWrapper>
  )
}

export default FormResponse
